export const animation = {
  maskShowDuration: 0.6,
  maskHideDuration: 0.75,
  lineDuration: 0.05,
  wordDuration: 0.04,
  charDuration: 0.005,
  rootMargin: '0px 0px -10% 0px',
}
